import Vue from 'vue'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    allProject: {},
    projectDetail: {},
    newServiceToken: {},
    createdTokenData: {},
    serviceList: [],
    packageList: []
  },
  getters: {
    getAllProject (state) {
      return state.allProject
    },
    getProjectDetailState (state) {
      return state.projectDetail
    },
    getServiceListState (state) {
      return state.serviceList
    },
    getPackageListState (state) {
      return state.packageList
    },
    getNewServiceTokenState (state) {
      return state.newServiceToken
    },
    getCreatedTokenDataState (state) {
      return state.createdTokenData
    }
  },
  actions: {
    async loadAllProject (context) {
      const userInfo = context.rootGetters['user/getUserDetail']
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      const responseData = await webServiceConnector.getAllProject(userInfo.userId)
      context.commit('setAllProject', responseData)
    },
    async createNewToken (context, { projectId, userId, name }) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      const responseData = await webServiceConnector.createNewToken(projectId, userId, name)
      context.commit('setNewServiceToken', responseData)
      return responseData
    },
    async addServiceToToken (context, { tokenId, serviceId, quota }) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.addServiceToToken(tokenId, serviceId, quota)
    },
    async addPackageToToken (context, { token, packageName, quota }) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.addPackageToToken(token, packageName, quota)
    },
    async editPackageInToken (context, { token, packageName, quota, name }) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.editPackageInToken(token, packageName, quota, name)
    },
    async deletePackageFromToken (context, { token, packageName }) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.deletePackageFromToken(token, packageName)
    },
    async addProject (context, { userId, newProjectDetail }) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.addProject(userId, newProjectDetail)
    },
    async addCreatedTokenData (context, { addedServiceList, tokenId }) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      const responseData = await webServiceConnector.getSingleTokenDetail(tokenId)
      context.commit('setCreatedTokenData', { addedServiceList, responseData })
      return {
        associatedServices: addedServiceList,
        createdAt: responseData.data.createdAt,
        lastAccess: 0,
        token: responseData.data.tokenId,
        name: responseData.data.name
      }
    },
    async getServiceList (context) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      const responseData = await webServiceConnector.getServiceList()
      context.commit('setServiceList', responseData)
      return responseData
    },
    async getPackageList (context) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      const responseData = await webServiceConnector.getPackageList()
      context.commit('setPackageList', responseData)
      return responseData
    },
    async getProjectDetail (context, projectId) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      const responseData = await webServiceConnector.getProjectDetail(projectId)
      context.commit('setProjectDetail', responseData)
      return responseData
    },
    async getProjectErrorCount (context, projectId) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      const responseData = await webServiceConnector.getProjectErrorCount(projectId)
      context.commit('setProjectErrorCount', { projectId, responseData })
      return responseData
    },
    async getSingleTokenDetail (context, token) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.getSingleTokenDetail(token)
    },
    async getSingleTokenDeepDetail (context, token) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.getSingleTokenDeepDetail(token)
    },
    async getTokenDetail (context, { projectId, token }) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.getTokenDetail(projectId, token)
    },
    async getTokensDetail (context, projectId) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.getTokensDetail(projectId)
    },
    async getProjectUsage (context, projectUsageData) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.getProjectUsage(projectUsageData)
    },
    async getProjectResponse (context, projectResponseData) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.getProjectResponse(projectResponseData)
    },
    async getProjectService (context, projectServiceData) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.getProjectService(projectServiceData)
    },
    async getUsageQuota (context, UsageQuotaData) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.getUsageQuota(UsageQuotaData)
    },
    async getBlockedCount (context, BlockedCountData) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.getBlockedCount(BlockedCountData)
    },
    async getModelListByToken (context, token) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.getModelListByToken(token)
    },
    async getModelDetailByModelId (context, { modelId, token }) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.getModelDetailByModelId(modelId, token)
    },
    async updateProject (context, projectInfo) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      const responseData = await webServiceConnector.updateProjectInfo(projectInfo)
      context.commit('updateProjectDetail', responseData)
      return !!responseData
    },
    async editQuota (context, { token, serviceId, quota, name }) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.editQuota(token, serviceId, quota, name)
    },
    async removeServiceFromToken (context, { token, serviceId }) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.removeServiceFromToken(token, serviceId)
    },
    async deleteToken (context, { projectId, userId, token }) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.deleteToken(projectId, userId, token)
    },
    async deleteProject (context, { userId, projectId }) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.deleteProject(userId, projectId)
    },
    async clearProjectDetail (context) {
      context.commit('clearProjectDetail')
    },
    // Classification
    async trainWithFile (context, data) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.trainWithFile(data)
    },
    async trainWithJSONString (context, obj) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.trainWithJSONString(obj)
    },
    async deleteModel (context, data) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.deleteModel(data)
    },
    async changeModelName (context, data) {
      const webServiceConnector = context.rootGetters['user/getWebServiceConnector']
      return webServiceConnector.changeModelName(data)
    }
    // Classification
  },
  mutations: {
    setAllProject (state, data) {
      state.allProject = data || { projects: [] }
    },
    setProjectDetail (state, data) {
      Vue.set(state.projectDetail, data.id, data)
    },
    updateProjectDetail (state, data) {
      Vue.set(state.projectDetail[data.projectId], 'name', data.projectName)
      Vue.set(state.projectDetail[data.projectId], 'description', data.description)
      state.allProject.projects.forEach(proj => {
        if (proj.id === data.projectId) {
          Vue.set(proj, 'name', data.projectName)
          Vue.set(proj, 'description', data.description)
        }
      })
    },
    setProjectErrorCount (state, { projectId, responseData }) {
      // Add new key into projectDetail so we can use projectDetail to display every information we need in ProjectDetail.vue
      Vue.set(state.projectDetail[projectId], 'errorCount', responseData)
    },
    clearProjectDetail (state, data) {
      state.projectDetail = {}
    },
    setServiceList (state, data) {
      state.serviceList = _.cloneDeep(data)
    },
    setPackageList (state, data) {
      state.packageList = _.cloneDeep(data)
    },
    setNewServiceToken (state, responseData) {
      Vue.set(state.newServiceToken, responseData.data.data.projectId, responseData.data.data)
    },
    setCreatedTokenData (state, { addedServiceList, responseData }) {
      Vue.set(state.createdTokenData, 'associatedServices', addedServiceList)
      Vue.set(state.createdTokenData, 'createdAt', responseData.data.createdAt)
      Vue.set(state.createdTokenData, 'lastAccess', 0)
      Vue.set(state.createdTokenData, 'token', responseData.data.tokenId)
    }
  }
}
